/**
 * @module FE-CU30_ハウスサポート等お問い合わせ画面
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';

const PAGE_ID = 'FE-CU30';

export default {
  name: 'HouseSupport',
  components: {
    Header,
    PcPageTitle,
    MobileFooter,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU30ハウスサポート等お問い合わせ画面.健康相談等'),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU30ハウスサポート等お問い合わせ画面.C0001'
      ),
      isActive: true,
      contactUsInfoList: [],
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * 外部リンクを開く
     * @param {*} url リンク先URL
     */
    externalLink(url) {
      if (this.$isMobileApp) {
        NativeApi.openBrowserApp(url);
      } else {
        window.open(url, '_blank');
      }
    },
    active: function () {
      this.isActive = !this.isActive;
    },
    /**
     * 画面遷移処理
     * @param {*} url 遷移先URL
     */
    link(url) {
      this.$router.push({
        path: url,
      });
    },
    /**
     * 電話アプリを起動
     * @param {*} tel 電話番号
     */
    call(tel) {
      NativeApi.openTelApp(tel); // 電話アプリを起動
    },
    /**
     * 初期化処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    init: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     contactUsInfoList: [
            //       {
            //         contactUsName: "相談窓口",
            //         contactUsComment: "10:00~16:00（土・日・祝日は除く）",
            //         contactUsPhoneNumber: "00-0000-0001",
            //         contactUsUrl: "https://www.alsok.co.jp/",
            //       },
            //       {
            //         contactUsName: "お問い合わせ先名称2",
            //         contactUsComment: "08:00~18:00（土・日・祝日は除く）",
            //         contactUsPhoneNumber: "00-0000-0002",
            //         contactUsUrl: "https://www.alsok.co.jp/",
            //       },
            //       {
            //         contactUsName: "お問い合わせ先名称3",
            //         contactUsComment: "09:00~19:00（土・日・祝日は除く）",
            //         contactUsPhoneNumber: "00-0000-0003",
            //         contactUsUrl: "https://www.alsok.co.jp/",
            //       },
            //       {
            //         contactUsName: "お問い合わせ先名称4",
            //         contactUsComment: "10:00~20:00（土・日・祝日は除く）",
            //         contactUsPhoneNumber: "00-0000-0004",
            //         contactUsUrl: "https://www.alsok.co.jp/",
            //       },
            //       {
            //         contactUsName: "お問い合わせ先名称5",
            //         contactUsComment: "11:00~21:00（土・日・祝日は除く）",
            //         contactUsPhoneNumber: "00-0000-0005",
            //         contactUsUrl: "https://www.alsok.co.jp/",
            //       },
            //     ],
            //   },
            // };

            // 取得したデータを画面に出力する。
            this.contactUsInfoList = apiData.contentsInfo.contactUsInfoList;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      return apiData;
    },
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU30ハウスサポート等お問い合わせ画面.健康相談等'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU30ハウスサポート等お問い合わせ画面.C0001'
        ),
      };
    },
    nativeError() {
      return this.$store.getters['appInfo/getNativeError'].errorCode;
    },
  },
  watch: {
    nativeError(newVal) {
      if (NativeCallback.codeInclude(newVal, '10-E0002')) {
        // 電話アプリ起動失敗時
        this.$errorDialog('$vuetify.メッセージ一覧.FECU30ハウスサポート等お問い合わせ画面.E0001');
      } else if (NativeCallback.codeInclude(newVal, '10-E0001')) {
        // 外部リンクブラウザ起動失敗時
      }
      this.$store.commit('appInfo/setNativeError', { errorCode: '' });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    let param = '/api/contactUsHouseSupport/init';

    let queries = {};

    if (this.$store.getters['isLoggedIn']) {
      queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '', //端末情報 localStorageから取得
      };
    }

    let method = 'post';
    // APP_CU3001
    await this.init(param, queries, method);

    //通信が遅すぎると白画面が目立つが、ここで画面表示【initが貰えないと電話番号が表示されない。ローディングマークもないのでいったんココ】
    this.isShowPage = true;
  },
};
